import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'transaction-log-management',
    template: require('./transaction-log-management.html')
})
export class TransactionLogManagementComponent implements OnInit {
    private toDate: Date = null;
    private fromDate: Date = null;
    
    ngOnInit(): void {
        this.setDates()
    }


    setDates(){
        var today = new Date();
        var tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        today.setFullYear(today.getFullYear() - 20);

        today.setUTCHours(0);
        tomorrow.setUTCHours(0);

        today.setUTCMinutes(0);
        tomorrow.setUTCMinutes(0);

        today.setUTCSeconds(0);
        tomorrow.setUTCSeconds(0);

        this.toDate = tomorrow;
        this.fromDate = today;
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/transaction-log/transaction-log-management.component.ts